import { __extends } from "tslib";
import { TagDeliveryStreamInput, TagDeliveryStreamOutput } from "../models/models_0";
import { deserializeAws_json1_1TagDeliveryStreamCommand, serializeAws_json1_1TagDeliveryStreamCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var TagDeliveryStreamCommand = /** @class */ (function (_super) {
    __extends(TagDeliveryStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function TagDeliveryStreamCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    TagDeliveryStreamCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "FirehoseClient";
        var commandName = "TagDeliveryStreamCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: TagDeliveryStreamInput.filterSensitiveLog,
            outputFilterSensitiveLog: TagDeliveryStreamOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    TagDeliveryStreamCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1TagDeliveryStreamCommand(input, context);
    };
    TagDeliveryStreamCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1TagDeliveryStreamCommand(output, context);
    };
    return TagDeliveryStreamCommand;
}($Command));
export { TagDeliveryStreamCommand };
//# sourceMappingURL=TagDeliveryStreamCommand.js.map